export const BLUESKY_MAX_DESCRIPTION_CHARS = 300;
